import '@rdfjs/data-model';
import '../../rdf.internal.mjs';
import 'http-link-header';
import 'n3';
import '../../rdfjs.mjs';
import { getThing, createThing } from '../../thing/thing.mjs';
import 'cross-fetch';
import { internal_getAcr } from '../control.internal.mjs';
import { getDefaultAccessControlUrl } from './getDefaultAccessControlUrl.mjs';
import 'uuid';

//
/** @hidden */
function getDefaultAccessControlThing(resource, name) {
    const acr = internal_getAcr(resource);
    const defaultAccessControlUrl = getDefaultAccessControlUrl(resource, name);
    const accessControlThing = getThing(acr, defaultAccessControlUrl);
    if (accessControlThing === null ||
        typeof accessControlThing === "undefined") {
        return createThing({ url: defaultAccessControlUrl });
    }
    return accessControlThing;
}

export { getDefaultAccessControlThing };
